import api from './index';
import axios from 'axios';

// Create a separate client for shared API
const sharedApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://rebase.api.seasideapis.com',
  headers: {
    'Accept': 'shared api; version=1',
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include auth token for shared API
sharedApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const companiesAPI = {
  // Search companies by name using shared API
  searchCompanies: (searchTerm) => {
    return sharedApi.get('/history_companies', {
      params: { search_term: searchTerm }
    });
  },
  
  // Create a new company using applicant API
  createCompany: (name) => {
    return api.post('/applicants/history_companies', { name });
  }
};

export default companiesAPI;
